import { createActionGroup, emptyProps } from '@ngrx/store';

export const mapsActions = createActionGroup({
  source: 'Maps',
  events:{
    'Loading': emptyProps(),
    'Loaded': emptyProps(),
  }
});
